import "./QSSP.css";
import { ignoreEnter, handleFigureChange, handleFigureBlur } from "./utils/inputhandlers";
import useSPQSUndo from "../../hooks/useSPQSUndo";
import useSPQS from "../../hooks/useSPQS";
import { useNavigate, useLocation } from "react-router-dom";

const SPQSFormGroup = ({
  labelname,
  inputname,
  inputtype,
  style,
  readOnly,
  type,
  rowStyle,
  cplaceholder,
  required,
}) => {
  // General
  const navigate = useNavigate();
  // Load context data
  const { SPQS, setSPQS, setSPQSData } = useSPQS();
  const { SPQSEdits, editIDSPQS, setEditIDSPQS, editingFieldSPQS, setEditingFieldSPQS, undoListSPQS, inputRefsSPQS } =
    useSPQSUndo();
  return (
    <div className='form-group' style={rowStyle}>
      <label>{labelname}:</label>
      {readOnly ? (
        <input
          readOnly
          disabled
          type={type || "text"}
          style={{ border: "none" }}
          autoComplete='off'
          onKeyDown={ignoreEnter}
          onFocus={(e) => e.target.select()}
          value={SPQS?.[inputname] || ""}
          name={inputname}
          tabIndex={-1}
        />
      ) : (
        <input
          required={required === false ? false : true}
          type={type || "text"}
          name={inputname}
          value={SPQS?.[inputname] ? SPQS?.[inputname] : SPQS?.[inputname] === 0 ? 0 : ""}
          autoComplete='off'
          onKeyDown={ignoreEnter}
          onFocus={(e) => e.target.select()}
          onChange={(e) => handleFigureChange(e, inputtype, setSPQS, setSPQSData, setEditingFieldSPQS)}
          onBlur={(e) =>
            handleFigureBlur(
              e,
              inputtype,
              setSPQS,
              SPQSEdits,
              editIDSPQS,
              setEditIDSPQS,
              editingFieldSPQS,
              setEditingFieldSPQS,
              undoListSPQS
            )
          }
          style={style}
          placeholder={cplaceholder}
          ref={(el) => (inputRefsSPQS.current[inputname] = el)}
        />
      )}
    </div>
  );
};

export default SPQSFormGroup;
